 const ErrorType = {
  422: 'VALIDATION_ERROR',
  500: 'INTERNAL_SERVER_ERROR',
  401: 'AUTHENTICATION_FAILED',
  403: 'PERMISSION_DENIED',

  'VALIDATION_ERROR': 'VALIDATION_ERROR',
  'INTERNAL_SERVER_ERROR': 'INTERNAL_SERVER_ERROR',
  'AUTHENTICATION_FAILED': 'AUTHENTICATION_FAILED',
  'PERMISSION_DENIED': 'PERMISSION_DENIED',
  
  INTERNAL_CLIENT_ERROR: 'INTERNAL_CLIENT_ERROR'
};

export default ErrorType;